import apiClient from '../client';
import { ApiResponse, School, CreateSchoolDto, PaginationQuery, PaginationMeta } from '@/types';

export const schoolsApi = {
  getAll: async (params?: PaginationQuery & { stage?: number }): Promise<{ data: School[]; meta: PaginationMeta }> => {
    const response = await apiClient.get<ApiResponse<School[]>>('/schools', { params });
    return { data: response.data.data ?? [], meta: response.data.meta! };
  },

  getById: async (id: string): Promise<School> => {
    const response = await apiClient.get<ApiResponse<School>>(`/schools/${id}`);
    return response.data.data!;
  },

  create: async (dto: CreateSchoolDto): Promise<School> => {
    const response = await apiClient.post<ApiResponse<School>>('/schools', dto);
    return response.data.data!;
  },

  update: async (id: string, dto: Partial<CreateSchoolDto>): Promise<School> => {
    const response = await apiClient.patch<ApiResponse<School>>(`/schools/${id}`, dto);
    return response.data.data!;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/schools/${id}`);
  },

  exportStudentsCsv: async (stage?: number, term?: number): Promise<Blob> => {
    const params: Record<string, string> = {};
    if (stage !== undefined) params.stage = stage.toString();
    if (term !== undefined) params.term = term.toString();
    
    const response = await apiClient.get('/schools/export-students-csv', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },
};
